<ng-container *ngIf="!showSuccess, else success">
	<p><strong>Decline Reason</strong></p>
	<form [formGroup]="form">
		<ng-container>
			<app-input-control [controlDef]="reason" [inputType]="'textarea'"></app-input-control>
		</ng-container>
		<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
		<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20">
			<div nz-col class="gutter-row" [nzSpan]="12">
				<button type="button" class="btn btn-secondary btn-block"
					(click)="modal.destroy()">{{'moniepoint.cancel'|translate |
					titlecase}}</button>
			</div>
			<div nz-col class="gutter-row" [nzSpan]="12">
				<app-custom-submit-button [block]="true" [name]="'moniepoint.continue' | translate | titlecase"
					[submitting]="submittingForm" (submitForm)="submitRequest()">
				</app-custom-submit-button>
			</div>
		</div>
	</form>
</ng-container>

<ng-template #success>
	<app-non-modal-alert (confirm)="modal.destroy()" [message]="'Request was Successful'" [alertType]="'success'">
	</app-non-modal-alert>
</ng-template>